import React from 'react'
import { useNavigate } from 'react-router-dom'
import './busSeatSelection.css'
import './busBoarding.css'

// Static placeholder — no bus API exists yet, so boarding/dropping points below
// are hardcoded to match the reference design exactly (no state, no click
// behaviour). Once a bus API exists, this can be wired up for real. Content
// only (no tab bar) — rendered by SeatBookingPanel.jsx alongside the
// BOARDING/DROP POINTS tab.
const POINTS = [
    {
        title: 'ISBT Kashmiri Gate Inside Arrival Platform Near 53 & 54',
        sub1: 'Exit Metro Gate Number 8 Go',
        sub2: 'landmarkL Laxmi Holidays Bay/Platform Arrival Near 53 and 54',
        time: '30 Apr • 06:30 PM',
        distance: '0 km away',
    },
    {
        title: 'ISBT Kashmiri Gate Inside Arrival Platform Near 53 & 54',
        sub1: 'Exit Metro Gate Number 8 Go',
        sub2: 'landmarkL Laxmi Holidays Bay/Platform Arrival Near 53 and 54',
        time: '30 Apr • 06:30 PM',
        distance: '10 km away',
    },
]

const PointCard = ({ point }) => (
    <div className='boardingCard'>
        <div className='boardingCard__head'>
            <div className='boardingCard__title'>{point.title}</div>
            <span className='boardingCard__radio' />
        </div>
        <div className='boardingCard__sub'>{point.sub1}</div>
        <div className='boardingCard__sub'>{point.sub2}</div>
        <div className='boardingCard__divider' />
        <div className='boardingCard__meta'>
            <span className='boardingCard__time'>{point.time}</span>
            <span className='boardingCard__distance'>{point.distance}</span>
        </div>
    </div>
)

const BusBoarding = () => {
    const navigate = useNavigate()

    return (
        <div className='seatSelectPanel'>
            <div className='seatSelectPanel__title'>Select Boarding/Drop Points</div>

            <div className='boardingCols'>
                <div className='boardingCol'>
                    <div className='boardingCol__title'>Boarding Point</div>
                    {POINTS.map((point, index) => (
                        <PointCard point={point} key={index} />
                    ))}
                </div>
                <div className='boardingCol'>
                    <div className='boardingCol__title'>Dropping Point</div>
                    {POINTS.map((point, index) => (
                        <PointCard point={point} key={index} />
                    ))}
                </div>
            </div>

            <div className='seatSelectPanel__footer'>
                <div>
                    <div className='seatSelectPanel__footerPrice'>₹1,600</div>
                    <div className='seatSelectPanel__footerSeats'>2 Seats</div>
                </div>
                <button type='button' className='commonBtn seatSelectPanel__footerBtn' onClick={() => navigate('/bus-booking-detail')}>
                    Fill Passenger Details
                </button>
            </div>
        </div>
    )
}

export default BusBoarding
